( (window, document) => {
  "use strict";
  const $ = window.jQuery;

  let simple_slider = document.querySelectorAll('.vodl-simple-slider'),
    alreadyTracked = false;

  const trackClicks = (item) => {
    const slider = item[0].closest('.vodl-simple-slider');

    if (slider && slider.classList.contains('vplus-slider')) {
      trackOEWA('/vplus-slider');
    }
  };

  const trackGA = (category, url) => {
    const eventCategory = category || false,
      eventLabel = url || false;

    if (category && url && !alreadyTracked) {
      alreadyTracked = true;
      const eventData ={
        event: 'genericEvent',
        eventCategory,
        eventAction: 'click',
        eventLabel,
      };

      dataLayer.push(eventData);

      document.dispatchEvent(
        new CustomEvent('hansrmdtevent', { detail: eventData })
      );
    }
  };

  const trackOEWA = (type) => {
    if (typeof oewa_data === 'undefined') {
      return;
    }

    const oldOEWA = oewa_data.cp,
      modOEWA = oewa_data.cp, //get it from referer page
      agency = modOEWA.substring(modOEWA.lastIndexOf('/') + 1),
      elements = modOEWA.split('/');

    if (modOEWA.includes('Homepage')) {
      elements[1] = 'Nachrichten';
      elements[2] = 'LokaleNachrichten';
    }

    let userAgent = navigator.userAgent;
    let device = '';
    if (/android/i.test(userAgent)) {
      device = 'Android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      device = 'iOS';
    }

    if (device === 'Android' || device === 'iOS') {

      //new OEWA tracking code
      oewa_data['cp'] =
          elements[0] +
          '/' +
          elements[1] +
          '/' +
          elements[2] +
          '/moewa' +
          type +
          '/' +
          agency;
    } else {
      //new OEWA tracking code
      oewa_data['cp'] =
          elements[0] +
          '/' +
          elements[1] +
          '/' +
          elements[2] +
          type +
          '/' +
          agency;
    }

    if (typeof window.IOMm !== 'undefined') {
      window.IOMm('pageview', { cp: oewa_data['cp'] });
    }

    oewa_data['cp'] = oldOEWA; //set OEWA.cp to old value
  };

  const handleItemClick = (e) => {
    const sliderItemLink = e.currentTarget.querySelector('.vodl-teaser-card-link'),
      slider = sliderItemLink.closest('.vodl-simple-slider');

    if (sliderItemLink && sliderItemLink.href) {
      let eventCategory = 'vplus_slider';

      if (slider && slider.dataset && slider.dataset.trackingPrefix) {
        eventCategory = slider.dataset.trackingPrefix + '-' + eventCategory;
      }

      trackGA(eventCategory, sliderItemLink.href);
    }
  };

  const onSliderLoad = () => {
    window.dispatchEvent(new Event('vodl_lazyload_images'));
  };

  // re-fetch all available not yet intitialized slider
  const init_sliders_onEvent = () => {
    simple_slider = document.querySelectorAll('.vodl-simple-slider.pre-init');
    simple_slider.forEach(slider => {
      init_sliders(slider);
    });
  };

  const init_sliders = (slider) => {
    const slider_wrapper = slider.querySelector('.vodl-simple-slider__carousel-slider');

    let sliderAttr = {
      speed: 250,
      minSlides: 1,
      maxSlides: 4,
      moveSlides: 1,
      responsive: false,
      infiniteLoop: true,
      hideControlOnEnd: true,
      onSliderLoad: onSliderLoad,
    };

    if (slider.classList.contains('vplus-slider')) {
      const sliderItems = slider.querySelectorAll('.vodl-simple-slider__carousel-slider-item'),
        prevElement = slider.querySelector('.vodl-simple-slider__prev'),
        nextElement = slider.querySelector('.vodl-simple-slider__next');

      sliderAttr = {
        ...sliderAttr,
        prevSelector: prevElement,
        nextSelector: nextElement,
        prevText: '<div class="vodl-simple-slider__prev-arrow"></div>',
        nextText: '<div class="vodl-simple-slider__next-arrow"></div>',
        onSlideAfter: trackClicks,
      };

      if (sliderItems.length > 0) {
        sliderItems.forEach(item => {
          item.addEventListener('click', handleItemClick);
        });
      }
    }

    $(slider_wrapper).bxSlider(sliderAttr);

    slider_wrapper.addEventListener('touchmove', (e) => {
      e.preventDefault();
    });

    // remove class to for newPage event
    slider.classList.remove('pre-init');
  };

  $(document).ready(() => {
    const premium_content = document.querySelector('.vodl-region-article__premium-content');

    simple_slider.forEach(slider => {
      if (premium_content) {
        document.addEventListener('vodl_show_full_content', init_sliders_onEvent, false);

        // get the closest sidebar element and check if the sidebar is visible
        const sidebar = slider.closest('.vodl-region-article__content');
        if (sidebar && !sidebar.hidden) {
          init_sliders(slider);
        }

        return;
      }

      init_sliders(slider);
    });

    // Initialize event listener for lazy sliders.
    window.addEventListener('newPage', init_sliders_onEvent, false);
  });
})(window, document);
